import * as CertificationWatermark from '@tableau/certification-watermark';
import { CertificationStatusChipOrIcon } from '@tableau/data-catalog-client-components';
import { SiteUrls } from '@tableau/shared-urls';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';

import { CERTIFIED_INDICATOR_TYPE } from '~src/app/quality/DataQualityType';
import { IContentInfo } from '~src/ts/models/IContentInfo';
import { dataQualityIndicatorInfoToDataQualityIndicator, IDataQualityIndicatorInfo } from '~src/ts/models/IDataQualityIndicatorInfo';

import { contentTypeToAssetType, urlForContentType } from './DataQualityIndicatorCell';

export interface CertificationCellOptions {
  isCertified: (row: DataGrid.Row) => boolean;
  getTooltipProps: (row: DataGrid.Row) => CertificationWatermark.CertificationTooltipProps;
}

const CertificationCellStyle: React.CSSProperties = {
  position: 'relative',
  left: '11px',
  top: '2px'
};

function getIndicatorFromRow(row: DataGrid.Row): IDataQualityIndicatorInfo | null {
  switch (row.data.contentType) {
    case 'datasource':
      const indicator = row.data?.dataQualityIndicators?.filter((i: { type: string }) => i.type === CERTIFIED_INDICATOR_TYPE) ?? null;
      return indicator[0] ?? null;
    case 'databaseWithCrass':
    case 'tableWithCrass':
      const certification = row.data?.dataQualityCertifications[0] ?? null;

      if (certification) {
        certification.type = certification.warningType;
      }

      return certification;
    default:
      return null;
  }
}

export function CertificationCell(siteUrls: SiteUrls, options: CertificationCellOptions):
  React.Factory<BodyCell.Props> {
  return React.createFactory(class extends React.Component<BodyCell.Props, any> {
    render() {
      if (!options.isCertified(this.props.row)) {
        return null;
      }

      const indicator = getIndicatorFromRow(this.props.row);

      if (!indicator) {
        return null;
      }

      const contentTypeWithDQI = this.props.row.data as IContentInfo;
      const assetUrl = urlForContentType(siteUrls, contentTypeWithDQI);
      const assetType = contentTypeToAssetType(contentTypeWithDQI);

      return (
        <div className="tb-certification-cell" data-tb-test-id='CertificationCell' style={CertificationCellStyle}>
          <CertificationStatusChipOrIcon
            subjectArea={assetType}
            kind={'vizportal'}
            anchoredAsset={{
              assetName: this.props.row.data.name,
              assetType: assetType,
              assetUrl: _ => assetUrl,
            }}
            anchoredCertifications={[dataQualityIndicatorInfoToDataQualityIndicator(indicator)]}
            iconOnly={true}
            urls={siteUrls}
            linksDisabled={false}
          />
        </div>
      );
    }
  });
}
